export default __webpack_public_path__ + "static/media/members_receive_2.57a3b52b.jpg";